module.exports = __webpack_public_path__ + "img/icon_vorbeugung_folgeerkrankungen.a8b6147e.svg";